import stylesheet from './CardGrid.scss?inline';

import CustomComponent from '../../base/customComponent/CustomComponent';

class NXTCardGrid extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const element = document.createElement('div');
        element.classList.add('card-grid');
        element.innerHTML = '<slot></slot>';
        return element;
    }
}

customElements.define('nxt-card-grid', NXTCardGrid);
